import { AxiosInstance } from 'axios'
import type { VCCardProps } from '@dc-shared-web/hooks/api/comparison/types'

type SharedDocumentInfoParams = {
  crunchUuid: string
}

/** Returns a list of comparisons for a given crunch uuid */
export const fetchComparisonList = async (
  apiClient: AxiosInstance,
  params: SharedDocumentInfoParams
): Promise<VCCardProps[]> => {
  const { data } = await apiClient.get(
    `v1/comparison/${params.crunchUuid}/comparisons`
  )
  return data.data
}
